import props, { buttonSize, buttonType } from './types'
import Button from './Button'

export type ButtonProps = props
export const ButtonType = {
  buttonSize,
  buttonType
}

export default Button
